import React from 'react'
import { useTranslations } from 'next-intl';

type Props = {
  className?: string;
  text?: string;
}

const Loading: React.FC<Props> = ({ className, text }) => {
  const translation = useTranslations('components.Loading')
  return (
    <div className={`tw-flex tw-items-center ${className || ''}`}>
      <div className="spinner-border tw-text-brand-navy"></div>
      <div className="tw-ml-2">{ text || `${translation('loading')}...` }</div>
    </div>
  )
}

export default Loading
